export const checkFirebaseSupport = () => {
	// Check if the browser supports service workers
	const hasServiceWorkerSupport = 'serviceWorker' in navigator;

	// Check if the browser supports notifications
	const hasNotificationSupport = 'Notification' in window;

	// Check if the browser is in a secure context (needed for service workers)
	const isSecureContext = window.isSecureContext;

	return {
		isSupported:
			hasServiceWorkerSupport && hasNotificationSupport && isSecureContext,
		features: {
			serviceWorker: hasServiceWorkerSupport,
			notifications: hasNotificationSupport,
			secureContext: isSecureContext,
		},
	};
};
